import {
  FORCE_EXPAND,
  RESET,
  SYSTEM_COLLAPSE,
  SYSTEM_EXPAND,
  TOGGLE_COLLAPSE,
  USER_COLLAPSE,
  USER_EXPAND,
} from 'common/actions/row-groups/types';
import { RowsGroups, RowsGroupsAction } from './types';

const rowsGroupsReducer = (currentState: RowsGroups, action: RowsGroupsAction): RowsGroups => {
  switch (action.type) {
    case USER_EXPAND:
    case USER_COLLAPSE:
    case SYSTEM_EXPAND:
    case SYSTEM_COLLAPSE: {
      return { ...currentState, [action.row]: action.type };
    }

    // Stored as SYSTEM_EXPAND so every consumer treats it as expanded and it
    // never persists to the user's saved fold preferences.
    case FORCE_EXPAND: {
      return { ...currentState, [action.row]: SYSTEM_EXPAND };
    }

    case TOGGLE_COLLAPSE: {
      const row = currentState[action.row];
      const isCollapsed = row === SYSTEM_COLLAPSE || row === USER_COLLAPSE;
      if (Array.isArray(action.collapseGroups)) {
        const newState = { ...currentState };
        action.collapseGroups.forEach(group => {
          const groupState = currentState[group];
          const groupIsCollapsed = groupState === SYSTEM_COLLAPSE || groupState === USER_COLLAPSE;
          newState[group] = groupIsCollapsed ? SYSTEM_EXPAND : SYSTEM_COLLAPSE;
        });
        return newState;
      }
      return {
        ...currentState,
        [action.row]: isCollapsed ? USER_EXPAND : USER_COLLAPSE,
      };
    }

    case RESET:
      return { ...action.payload };

    default:
      return currentState;
  }
};

export default rowsGroupsReducer;
